import { render, staticRenderFns } from "./DomainProfile.vue?vue&type=template&id=6de952f2&"
import script from "./DomainProfile.vue?vue&type=script&lang=js&"
export * from "./DomainProfile.vue?vue&type=script&lang=js&"
import style0 from "./DomainProfile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports